import { trackEvent } from "@/api/generated";
import { isDev, isLocal } from "@/config/env";
import { useAuthStore } from "@/store";

export const trackServerEvent = (
  event: string,
  properties?: Record<string, unknown>,
): void => {
  const anonymousId = useAuthStore.getState().anonymousUserId ?? undefined;
  trackEvent({ event, properties, anonymous_id: anonymousId })
    .then(() => {
      if (isLocal || isDev) {
        console.log("TRACK (server)", event, properties);
      }
    })
    .catch(() => {});
};
